export default __webpack_public_path__ + "static/media/neworder.54cf3f90.jpeg";